import adminApiFetch from './apiService';

const productionBomService = {
  // 獲取配方列表（用於表格）
  getRecords: async (params = {}) => {
    const res = await adminApiFetch('production_boms/get_records', {
      method: 'POST',
      body: params
    });
    return res.json();
  },

  // 獲取所有配方 ID（用於篩選）
  getIds: async (params = {}) => {
    const res = await adminApiFetch('production_boms/get_ids', {
      method: 'POST',
      body: params
    });
    return res.json();
  },

  // 獲取單個配方
  get: async (id) => {
    const res = await adminApiFetch(`production_boms/${id}`, {
      method: 'GET'
    });
    return res.json();
  },

  // 創建配方
  create: async (data) => {
    const res = await adminApiFetch('production_boms', {
      method: 'POST',
      body: { production_bom: data }
    });
    return res.json();
  },

  // 更新配方
  update: async (id, data) => {
    const res = await adminApiFetch(`production_boms/${id}`, {
      method: 'PUT',
      body: { production_bom: data }
    });
    return res.json();
  },

  // 刪除配方
  delete: async (id) => {
    const res = await adminApiFetch(`production_boms/${id}`, {
      method: 'DELETE'
    });
    return res.json();
  },

  // 匯出配方
  export: async (ids) => {
    const res = await adminApiFetch('production_boms/export', {
      method: 'POST',
      body: { ids }
    });
    return res.json();
  }
};

export { productionBomService };
export default productionBomService;
